export const educationData = [
    {
        id: 3,
        institution: 'NED University of Engineering & Technology',
        course: 'Bachelors in Computer Science & Information Technology',
        startYear: '2020',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Gulshan Degree College',
        course: 'Higher Secondary Education',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 1,
        institution: 'Shaheen Public School',
        course: 'Secondary Education',
        startYear: '2007',
        endYear: '2018'
    },
]